/**
 * Axios configuration.
 *
 * Auth strategy: HttpOnly cookies are the PRIMARY auth mechanism (set by the
 * backend on login). They are immune to XSS. We also send a Bearer token from
 * localStorage as a fallback for legacy clients — this branch is being phased
 * out and SHOULD NOT be relied upon for new features.
 *
 * Setting `axios.defaults.withCredentials = true` ensures cookies are sent on
 * every cross-origin request to the API.
 */
import axios from 'axios';

// Send HttpOnly auth cookies on every request (cross-origin safe via CORS allow_credentials)
axios.defaults.withCredentials = true;

// Request interceptor to add Authorization header (legacy fallback only)
axios.interceptors.request.use(
  (config) => {
    if (config.withCredentials !== false) {
      config.withCredentials = true;
    }
    // Legacy Bearer token fallback — kept for backwards compatibility.
    // TODO: remove once all flows are verified cookie-only.
    const token = localStorage.getItem('session_token');
    if (token && !config.headers['Authorization']) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401 errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Auth context handles redirect — we don't clear tokens here
    }
    return Promise.reject(error);
  }
);

export default axios;
